import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Message from "../../components/Message";
import { MinorUserContext } from "../../context/UserNameProvider";
import { useDispatch, useSelector } from "react-redux";
import { setPayMethod as updatePayMethod } from '../../redux/userSlice';
import { reset as insuranceReset } from '../../redux/insuranceSlice';
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function ParentInstructions() {
  const userName = useContext(MinorUserContext);
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const navigate = useNavigate();
  const { returning = false } = location.state || {};
  const dispatch = useDispatch();
  const [nextPath, setNextPath] = useState(null);

  useEffect(() => {
    if (returning) {
      setNextPath("/feeling-now");
      return;
    }

    // TBD - for future self pay only state flows add here || user.address?.state === 'XY' ||
    const isSelfPayFlow = user.uberDoc || user.selfPayIntake;

    if (isSelfPayFlow) {
      const path = "/whats-next";
      setNextPath(path);
    } else {
      setNextPath("/insurance/provider");
    }

    if (nextPath === "/whats-next" || "/tried-before") {
      dispatch(updatePayMethod("self"));
      dispatch(insuranceReset());
    }
  }, [returning, user, dispatch, nextPath]);

  const handleBack = () => {
    setPageAndDeferNavigate(dispatch, '/minor/weight', () =>
      navigate('/minor/weight', { state: { returning: returning } })
    );
  };

  return (
    <Message
      onBack={handleBack}
      title="Instructions to parents"
      subtitle={<span>For the following questions, <strong>please answer on behalf of {userName.firstName}, rather than yourself.</strong></span>}
      next={nextPath}
      selected={true}
    />
  );
}
